import { render, staticRenderFns } from "./UserActivityWidget.vue?vue&type=template&id=06051870&scoped=true&"
import script from "./UserActivityWidget.vue?vue&type=script&lang=js&"
export * from "./UserActivityWidget.vue?vue&type=script&lang=js&"
import style0 from "./UserActivityWidget.vue?vue&type=style&index=0&id=06051870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06051870",
  null
  
)

export default component.exports